import React, { useEffect, useMemo, useState } from 'react';
import fisiIconDrop from '../../../images/FisTaskIcon.png';
import HttpClient from '../../../utils/HttpClient';
import TaskPopUp from '../TaskPopUp';
import { useLanguage } from '../../../Providers/LanguageContext';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';

const TodoList = props => {
  const { language } = useLanguage();
  const { taskData, getTaskData, setTaskData, fetchEntireTask } = props;

  const [modala, setModala] = useState(false);
  const [taskDetailData, setTaskDetailData] = useState({});
  const [entireProjects, setEntireProjects] = useState([]);
  const [projectId, setProjectId] = useState('');
  const [allTaskData, setAllTaskData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [intendedTaskId, setIntendedTaskId] = useState('');
  const [intendedTaskStatus, setIntendedTaskStatus] = useState('');
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);


  // Add a new state for filtered tasks
  const [filteredTaskData, setFilteredTaskData] = useState([]);

  useEffect(() => {
    setAllTaskData(taskData);
    setFilteredTaskData(taskData); // Initialize filtered data with all tasks
  }, [taskData]);

  useEffect(() => {
    getTaskData();
    fetchEntireTask();
  }, []);


  // console.log("taskData: >>>>>> ", {
  //   taskData,
  //   getTaskData,
  //   setTaskData,
  //   fetchEntireTask,
  // });

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> fetch project for filter <<<<<<<<<<<<<<<<<<<<<<<<<<<
  const fetchAllProjects = async () => {
    try {
      const response = await HttpClient.requestData('view-all-project', 'GET');
      if (response && response?.status) {
        setEntireProjects(response?.data);
      } else {
        toast.error(response?.message || 'Something Went Wrong!!!');
        setEntireProjects([]);
      }
    } catch (error) {
      toast.error(error?.message || 'Something Went Wrong!!!');
      setEntireProjects([]);
    }
  };

  // console.log("entireProjects: ", entireProjects);


  // useEffect(() => {
  //   // Get all tasks by flattening the status arrays
  //   console.log("allTaskData: ", allTaskData);

  //   const allTasks = allTaskData?.map(task => task.status).flat(1);

  //   // Extract unique project IDs using Set
  //   const uniqueProjectIds = [...new Set(allTasks?.map(task => task.assignToProject))].filter(Boolean);

  //   console.log('Unique Project IDs:', uniqueProjectIds);

  //   // If you need the full project objects with unique IDs:
  //   const uniqueProjects = allTasks?.reduce((acc, task) => {
  //     if (task.assignToProject && !acc.some(proj => proj._id === task.assignToProject)) {
  //       acc.push({
  //         _id: task.assignToProject,
  //         projectName: task.assignToProjectName
  //       });
  //     }
  //     return acc;
  //   }, []);

  //   console.log('Unique Projects:', uniqueProjects);
  //   setEntireProjects(uniqueProjects || []);
  // }, [allTaskData]);


  useEffect(() => {
    fetchAllProjects();
  }, []);


  // Filter projects based on date range
  const filteredProjects = useMemo(() => {
    if (!startDate && !endDate) {
      return entireProjects;
    }

    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    return entireProjects.filter(project => {
      const projectStart = new Date(project.startDate);
      const projectEnd = new Date(project.endDate);

      // If only start date is selected
      if (start && !end) {
        return projectStart >= start;
      }
      // If only end date is selected
      if (!start && end) {
        return projectEnd <= end;
      }
      // If both dates are selected
      if (start && end) {
        return projectStart >= start && projectEnd <= end;
      }
      return true;
    });
  }, [entireProjects, startDate, endDate]);

  // Filter tasks by project
  // const handleProjectFilter = async (selectedProjectId) => {
  //   try {
  //     setProjectId(selectedProjectId);
  //     if (!selectedProjectId) {
  //       return setTaskData(allTaskData);
  //     }

  //     // Filter tasks by selected project
  //     const filteredData = allTaskData.map(statusGroup => ({
  //       ...statusGroup,
  //       status: statusGroup.status.filter(task => task.assignToProject === selectedProjectId)
  //     }));

  //     setTaskData(filteredData);
  //   } catch (error) {
  //     toast.error('Error filtering tasks');
  //     console.error('Filter error:', error);
  //   }
  // };


  // Filter tasks by project and date range
  // const handleProjectFilter = async (selectedProjectId) => {
  //   try {
  //     setProjectId(selectedProjectId);
  //     if (!selectedProjectId) {
  //       return setTaskData(allTaskData);
  //     }

  //     // Filter tasks by selected project
  //     const filteredData = allTaskData.map(statusGroup => ({
  //       ...statusGroup,
  //       status: statusGroup.status.filter(task => {
  //         if (task.assignToProject !== selectedProjectId) return false;

  //         // Additional date filtering if dates are selected
  //         if (startDate || endDate) {
  //           const taskDate = new Date(task.selectDate || task.startDate);
  //           const start = startDate ? new Date(startDate) : null;
  //           const end = endDate ? new Date(endDate) : null;

  //           if (start && taskDate < start) return false;
  //           if (end && taskDate > end) return false;
  //         }

  //         return true;
  //       })
  //     }));

  //     setTaskData(filteredData);
  //   } catch (error) {
  //     toast.error('Error filtering tasks');
  //     console.error('Filter error:', error);
  //   }
  // };


  const handleProjectFilter = async (selectedProjectId) => {
    try {
      if (!selectedProjectId) {
        return setFilteredTaskData(allTaskData);
      }
      // console.log("handleProjectFilter called with:", selectedProjectId);

      // Filter tasks by selected project
      const filteredData = allTaskData.map(statusGroup => ({
        ...statusGroup,
        status: statusGroup.status.filter(task => {
          if (task.assignToProject !== selectedProjectId) return false;

          // Additional date filtering if dates are selected
          if (startDate || endDate) {
            const taskDate = new Date(task.selectDate || task.startDate);
            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;

            if (start && taskDate < start) return false;
            if (end && taskDate > end) return false;
          }

          return true;
        })
      }));

      setFilteredTaskData(filteredData);
    } catch (error) {
      toast.error('Error filtering tasks');
      console.error('Filter error:', error);
    }
  };

  useEffect(() => {
    if (isUpdate && selectedProjectId) {
      handleProjectFilter(selectedProjectId);
    }
    if (!selectedProjectId) {
      setIsUpdate(false);
      // If no project is selected, show all tasks
      setFilteredTaskData(allTaskData);
    }
  }, [isUpdate, selectedProjectId, allTaskData]);


  // console.log("taskData", taskData)

  // ********************drag and drop*******************
  const grid = 4;

  // when moves in a single list or column
  const reorder = (list, startIndex, endIndex) => {
    // console.log('list_startIndex_endIndex', list, startIndex, endIndex)
    const result = Array.from(list?.status);
    // console.log('resultreorder', result, list)
    const [removed] = result.splice(startIndex, 1);
    // console.log('removedreorder', removed)
    result.splice(endIndex, 0, removed);

    return result;
  };

  // console.log('getTaskData: ', taskData);

  // console.log('allTaskData: ', allTaskData);

  // Moves an item from one list to another list.
  const move = (source, destination, droppableSource, droppableDestination) => {
    // console.log('source_destination', source, destination, droppableSource, droppableDestination)
    const sourceClone = Array.from(source?.status);
    const destClone = Array.from(destination?.status);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    // console.log('droppableSource', droppableSource.droppableId, droppableDestination.droppableId)
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    // console.log('resultMove', result)
    return result;
  };

  //drag end: this function calles aftert drag end
  // const onDragEnd = result => {
  //   const { source, destination } = result;
  //   console.log('onDragEndresult', result);
  //   // dropped outside the list
  //   if (!destination) {
  //     return;
  //   }
  //   const sInd = +source.droppableId;
  //   const dInd = +destination.droppableId;
  //   // console.log('sInd_dInd', sInd, dInd);

  //   if (sInd === dInd) {
  //     const items = reorder(taskData[sInd], source.index, destination.index);
  //     // console.log('itemsReorder', items)
  //     const newState = [...taskData];
  //     newState[sInd]['status'] = items;

  //     // setTaskData(newState);
  //   } else {
  //     const resultArr = move(taskData[sInd], taskData[dInd], source, destination);
  //     const newState = [...taskData];
  //     newState[sInd]['status'] = resultArr[sInd];
  //     newState[dInd]['status'] = resultArr[dInd];

  //     console.log('resultmove', taskData[sInd], taskData[dInd], resultArr[dInd]);
  //     // setState(newState.filter(group => group.length));
  //     setTaskData(newState);

  //     updateStatus(result?.draggableId, taskData[dInd]);
  //     setIntendedTaskId(result?.draggableId);
  //     setIntendedTaskStatus(taskData[dInd]?.apiStatus);
  //     // fetchEntireTask();
  //   }
  // };

  const onDragEnd = result => {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;

    if (sInd === dInd) {
      // Reorder within the same column
      const items = reorder(filteredTaskData[sInd], source.index, destination.index);
      const newState = [...filteredTaskData];
      newState[sInd]['status'] = items;
      setFilteredTaskData(newState);
    } else {
      // Move between columns
      const resultArr = move(filteredTaskData[sInd], filteredTaskData[dInd], source, destination);
      const newState = [...filteredTaskData];
      newState[sInd]['status'] = resultArr[sInd];
      newState[dInd]['status'] = resultArr[dInd];

      // Update the actual task status in the database
      updateStatus(result.draggableId, filteredTaskData[dInd]);
    }
  };


  // console.log("intendedTaskId:", intendedTaskId);
  // console.log("intendedTaskStatus:", intendedTaskStatus);

  // Update the updateStatus function to reapply the filter after the API call:
  const updateStatus = async (id, destData) => {
    const data = {
      taskStatus: destData?.apiStatus,
    };
    const res = await HttpClient.requestData('update-task-eventDetails/' + id, 'PUT', data);
    if (res && res?.status) {
      setIsUpdate(true);

      fetchEntireTask(); // Fetch the updated task data after status update

      // // After status update, simply reapply the current project filter
      // if (selectedProjectId) {
      //   // Just call the existing filter function to refresh the data
      //   handleProjectFilter(selectedProjectId);
      // } else {
      //   // If no project filter, refresh with all tasks
      //   setFilteredTaskData(allTaskData);
      // }
    }
  };

  useEffect(() => {
    if (intendedTaskId && intendedTaskStatus) {
      updateStatus(intendedTaskId, { apiStatus: intendedTaskStatus });
    }
  }, [intendedTaskId, intendedTaskStatus]);

  // add style to the each list or column
  const getListStyle = isDraggingOver => {
    // console.log("isDraggingOver", isDraggingOver)
    return {
      background: isDraggingOver ? '#0c2637' : '#0c2637',
      padding: grid,
      width: 144,
    };
  };

  // console.log("filteredTaskData: ", filteredTaskData);
  const location = useLocation();


  // adds style to the each row
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? '#ffdd00' : '#fff',
    // borderTop: '2px solid #c9c9c9',
    // styles we need to apply on draggables
    ...draggableStyle,
  });
  // ********************End drag and drop*******************

  return (
    <div className='' >
      {
        location?.pathname !== "/favourite-dashboard" && (
          <div className='chart_title_div mb-3'>
        Kanban Board Analytics
        {/* <div className='fe_se_btn_wrp'>
          <button className='fe_se_btn'>New Features </button>
          <button className='fe_se_btn'>Select User</button>
        </div> */}
      </div>
        )
      }
      <div className=' mt-3' style={{
        // border: '4px solid #fff',
        padding: '30px',
        borderRadius: '25px'

      }}>
        <div className='filter_container_khanban'>
          <input type='date' placeholder='Project Start Date' value={startDate} onChange={e => setStartDate(e.target.value)} />
          <input type='date' placeholder='Project End Date' value={endDate} onChange={e => setEndDate(e.target.value)} />
          <select
            value={selectedProjectId}
            onChange={(e) => {
              handleProjectFilter(e.target.value);
              setSelectedProjectId(e.target.value);
            }}
            style={{
              padding: '8px 12px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              marginRight: '10px',
              backgroundColor: '#fff',
              color: '#333'
            }}
          >
            <option value="">All Projects</option>
            {/* {entireProjects?.map(project => (
            <option key={project._id} value={project._id}>
              {project.projectName}
            </option>
          ))} */}

            {filteredProjects?.map(project => (
              <option key={project._id} value={project._id}>
                {project.projectName}
              </option>
            ))}
          </select>
          {/* <button
          onClick={handleProjectFilter}
          style={{
            padding: '8px 16px',
            backgroundColor: '#FFDD00',
            color: '#0c2637',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Filter
        </button> */}
        </div>
        <h2 className='' style={{
          marginLeft: '10px',
          color:'black'
        }}>Status </h2>
        <div style={{
          background: "#0c2637",
          border: "none"
        }} className="addTaskTestDiv ">


          <DragDropContext onDragEnd={onDragEnd}>
            {filteredTaskData?.map((ele, ind) => {
              return (
                <div key={ind}>
                  <div className="addinnerTskDivOne addinnerTskDiv">
                    <div className="addInHeadDiv" style={ind === 0 ? { backgroundColor: '#ffdd00' } : { backgroundColor: ele?.color }}>
                      <span className="addInHeadSpan">{ele?.name}</span>
                      <span className="addInNumSpan">{ele?.open?.length}</span>
                    </div>

                    <Droppable key={ind} droppableId={`${ind}`}>
                      {(provided, snapshot) => {
                        return (
                          <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                            {...provided.droppableProps}
                          >
                            <div className="addMinTaskDiv">
                              {ele?.status?.map((item, index) => {
                                return (
                                  <div key={index}>
                                    <Draggable key={item?._id} draggableId={item?._id} index={index}>
                                      {(provided, snapshot) => (
                                        <div

                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          className='draggble_item'
                                            // style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                        >
                                          <div
                                            className="addInTextsDiv"
                                            key={index}
                                            onClick={() => {

                                              intendedTaskStatus ? setTaskDetailData({
                                                ...item,
                                                // taskStatus: intendedTaskStatus,
                                                taskStatus: item.taskStatus,
                                              }) : setTaskDetailData(item);

                                              setModala(true);
                                            }}
                                          >
                                            <p className="addMinPrepText">{item?.taskName}</p>
                                            <div className="addAssiTextDiv">
                                              <p className="addAssignText">
                                                {
                                                  item?.assignToUser
                                                    ?
                                                    <span>
                                                      {language.assign_to}: <span>{item?.assignToUser?.length}</span>
                                                    </span>
                                                    :
                                                    <span>{language.not_assigned}</span>
                                                }
                                              </p>
                                              <figure className="smallFisiIconFig">
                                                <img src={fisiIconDrop} alt="..." />
                                              </figure>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                      }
                                    </Draggable>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }}
                    </Droppable>

                    {/* <div>
                                            <button className="addInTaskBtn">+ Add New Task</button>
                                        </div> */}
                  </div>
                </div>
              );
            })}
          </DragDropContext>

          {/* Doing */}
          {/* <div className="addinnerTskDivTwo addinnerTskDiv">
                    <div
                        className="addInHeadDiv"
                        style={{ backgroundColor: "rgb(46, 195, 247)" }}
                    >
                        <span className="addInHeadSpan">Doing</span>
                        <span className="addInNumSpan">{taskData?.doing?.length}</span>
                    </div>
                    <div className="addMinTaskDiv">
                        {taskData?.doing?.map((item, i) =>
                            <div
                                key={i}
                                className="addInTextsDiv"
                                onClick={() => {
                                    setTaskDetailData(item)
                                    setModala(true)
                                }}
                            >
                                <p className="addMinPrepText">
                                    {item?.taskName}
                                </p>
                                <div className="addAssiTextDiv">
                                    <p className="addAssignText">
                                        Assigned to: <span>{item?.assignToUserName}</span>
                                    </p>
                                    <figure className="smallFisiIconFig">
                                        <img src={fisiIconDrop} alt="..." />
                                    </figure>
                                </div>
                            </div>
                        )
                        }
                    </div>
                    <div>
                        <button className="addInTaskBtn">+ Add New Task</button>
                    </div>
                </div> */}

          {/* Done */}
          {/* <div className="addinnerTskDivThree addinnerTskDiv">
                    <div
                        className="addInHeadDiv"
                        style={{ backgroundColor: "rgb(61, 241, 66)" }}
                    >
                        <span className="addInHeadSpan">Done</span>
                        <span className="addInNumSpan">{taskData?.done?.length}</span>
                    </div>
                    <div className="addMinTaskDiv">
                        {
                            taskData?.done?.map((item, i) =>
                                <div
                                    key={i}
                                    className="addInTextsDiv"
                                    onClick={() => {
                                        setTaskDetailData(item)
                                        setModala(true)
                                    }}
                                >
                                    <p className="addMinPrepText">
                                        {item?.taskName}
                                    </p>
                                    <div className="addAssiTextDiv">
                                        <p className="addAssignText">
                                            Assigned to: <span>{item?.assignToUserName}</span>
                                        </p>
                                        <figure className="smallFisiIconFig">
                                            <img src={fisiIconDrop} alt="..." />
                                        </figure>
                                    </div>
                                </div>
                            )

                        }
                    </div>
                    <div>
                        <button className="addInTaskBtn">+ Add New Task</button>
                    </div>
                </div> */}

          {/* Ideas */}
          {/* <div className="addinnerTskDivFour addinnerTskDiv">
                    <div
                        className="addInHeadDiv"
                        style={{ backgroundColor: "rgb(113, 129, 200)" }}
                    >
                        <span className="addInHeadSpan">Ideas</span>
                        <span className="addInNumSpan">{taskData?.ideas?.length}</span>
                    </div>
                    <div className="addMinTaskDiv">
                        {
                            taskData?.ideas?.map((item, i) =>
                                <div
                                    className="addInTextsDiv"
                                    key={i}
                                    onClick={() => {
                                        setTaskDetailData(item)
                                        setModala(true)
                                    }}
                                >
                                    <p className="addMinPrepText">
                                        {item?.taskName}
                                    </p>
                                    <div className="addAssiTextDiv">
                                        <p className="addAssignText">
                                            Assigned to: <span>{item?.assignToUserName}</span>
                                        </p>
                                        <figure className="smallFisiIconFig">
                                            <img src={fisiIconDrop} alt="..." />
                                        </figure>
                                    </div>
                                </div>
                            )

                        }
                    </div>
                    <div>
                        <button className="addInTaskBtn">+ Add New Task</button>
                    </div>
                </div> */}

          {/* On-Hold */}
          {/* <div className="addinnerTskDivFive addinnerTskDiv">
                    <div
                        className="addInHeadDiv"
                        style={{ backgroundColor: "rgb(247, 200, 31)" }}
                    >
                        <span className="addInHeadSpan">On-Hold</span>
                        <span className="addInNumSpan">{taskData?.onhold?.length}</span>

                    </div>
                    <div className="addMinTaskDiv">
                        {
                            taskData?.onhold?.map((item, i) =>
                                <div
                                    key={i}
                                    className="addInTextsDiv"
                                    onClick={() => {
                                        setTaskDetailData(item)
                                        setModala(true)
                                    }}
                                >
                                    <p className="addMinPrepText">
                                        {item?.taskName}
                                    </p>
                                    <div className="addAssiTextDiv">
                                        <p className="addAssignText">
                                            Assigned to: <span>{item?.assignToUserName}</span>
                                        </p>
                                        <figure className="smallFisiIconFig">
                                            <img src={fisiIconDrop} alt="..." />
                                        </figure>
                                    </div>
                                </div>
                            )

                        }
                    </div>
                    <div>
                        <button className="addInTaskBtn">+ Add New Task</button>
                    </div>
                </div> */}
        </div>
      </div>

      {modala && <TaskPopUp
        closemodal={setModala}
        detailData={taskDetailData}
        getTaskData={getTaskData}
        intendedTaskId={intendedTaskId}
        intendedTaskStatus={intendedTaskStatus}
        setIntendedTaskId={setIntendedTaskId}
        setIntendedTaskStatus={setIntendedTaskStatus}
        fetchEntireTask={fetchEntireTask}
        isFromTaskList={true}
        setIsUpdate={setIsUpdate}
      />}
    </div>
  );
};

export default TodoList;
